// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert.alert-danger {
  font-size: 11px !important;
  font-weight: 600 !important;
  padding: 0.5em 1.25em !important;
  width: 100% !important;
}

.d-flex {
  display: flex;
  align-items: center;
}

.gap-3 {
  gap: 12px;
}

.mb-3 {
  margin-bottom: 1rem;
}

.btn-action {
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-label {
  font-weight: 500;
  margin-right: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/registry/customers/add-customers/add-customers.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,2BAAA;EACA,gCAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;AACF","sourcesContent":[".alert.alert-danger{\r\n  font-size: 11px !important;\r\n  font-weight: 600 !important;\r\n  padding: 0.5em 1.25em !important;\r\n  width: 100% !important;\r\n}\r\n\r\n.d-flex {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.gap-3 {\r\n  gap: 12px;\r\n}\r\n\r\n.mb-3 {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.btn-action {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.action-label {\r\n  font-weight: 500;\r\n  margin-right: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
